import React, { useContext } from 'react'
import PropertyDetails from './propertyDetails'
import { getCity, getType } from '../constants'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@material-ui/core'
import { Context } from '../Store'
import { isEmpty } from 'lodash'

const MoreDetails = () => {
  const [state] = useContext(Context)
  const { i18n } = useTranslation()
  if (isEmpty(state.property)) {
    return null
  }
  const {
    translations: { [i18n.language]: city },
  } = getCity(state.property?.city)
  const {
    translations: { [i18n.language]: type },
  } = getType(state.property?.type)
  const propertyMainImage = state.property.images ? (
    <img
      src={`${process.env.REACT_APP_WEBSITE}/${state.property.images[0].url}`}
      className="rounded-md w-full h-24 object-cover object-center"
    />
  ) : (
    <div>No image available</div>
  )

  return (
    <>
      <Grid item style={{ height: '7rem', width: '7rem', minWidth: '7rem' }}>
        {propertyMainImage}
      </Grid>
      <Grid item>
        <Typography variant="subtitle1">{`${type} in ${state.property.street}, ${city}`}</Typography>
        <PropertyDetails noIcons />
      </Grid>
    </>
  )
}

export default MoreDetails
